import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { t } from 'i18next';
import type { PlatformOption } from '../constants';

export function PlatformOptionRow({
  option,
  selected,
  disabled,
  onSelect,
}: {
  option: PlatformOption;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
}) {
  const id = `platform-${option.key}`;

  return (
    <div
      className={cn(
        'relative flex p-4',
        selected ? 'bg-spark-accent-soft' : 'hover:bg-spark-surface-hover',
      )}
    >
      <div className="flex h-5 items-center">
        <input
          type="radio"
          id={id}
          name="platform"
          value={option.key}
          checked={selected}
          disabled={disabled}
          onChange={onSelect}
          className="hidden size-4 cursor-pointer border-spark-border-default text-spark-accent-solid focus:ring-spark-accent-hover disabled:pointer-events-none disabled:cursor-not-allowed"
        />
      </div>
      <span>
        <img
          src={option.logo}
          alt=""
          className={cn(
            'size-9 min-w-9 rounded-full border-2 bg-white',
            selected ? 'border-spark-accent' : 'border-spark-border-default',
          )}
        />
      </span>
      <label
        htmlFor={id}
        className={cn(
          'ml-3 flex w-full flex-col',
          disabled && selected ? '' : disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        )}
      >
        <span
          className={cn(
            'block font-medium text-sm',
            selected ? 'text-spark-accent' : 'text-spark-text-primary',
          )}
        >
          {t(option.nameKey)}
        </span>
        <span
          className={cn(
            'block text-sm',
            selected ? 'text-spark-accent' : 'text-spark-text-secondary',
          )}
        >
          {t(option.specificsKey)}
        </span>
      </label>
    </div>
  );
}
